
namespace RioERP.Reports {
    export class OrderCombinedReportColumns {
        static columnsKey = 'Reports.OrderCombinedReport';
    }
}